module.exports = __webpack_public_path__ + "static/media/Burger.c8237335.jpg";